import { React, useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";
import { } from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./login.css";
import { Redirect, Link, useHistory } from "react-router-dom";
import httpService from "../../services/http.service";
import loginImg from "../../assets/loginleft.png";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../common/loader";
import ErrorMessage from "../common/errorMsg";
import SuccessMessage from "../common/successMsg";
import { encryptText } from "./encryptanddecrypted/encryptAndDecrypt";

let CloudLogin = (props) => {
  const history = useHistory();
  const [login, setLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [initcustomerId, setInitCustomerId] = useState();
  const [initaccountNumber, setInitAccountNumber] = useState();
  const [initpassword, setInitPassword] = useState();
  const [initmobileNumber, setInitMobileNumber] = useState();
  let [expiry, setExpiry] = useState("");

  useEffect(() => {
    const queryString = window.location.hash.split("?")[1];
    if (!queryString) return;

    if (queryString === "success") {
      SuccessMessage("Payment successful!");
    } else if (queryString === "fail") {
      ErrorMessage("Payment failed!");
    }
  }, []);


  useEffect(() => {
    console.log(login, props.verifyTokenUser, history.location.pathname);
    if (!props.verifyTokenUser) {
      httpService.getByBoj("logout", {
        userId: localStorage.getItem("UserId"),
      });
      localStorage.clear();
      setLogin(true);
    }
    const customerID = localStorage.getItem("customerId");
    const type = localStorage.getItem("CloudUserType");
    const dataFirst = localStorage.getItem("dataFirst");
    if (customerID === "Admin" || type === "admin") {
      if (customerID === "Admin" && dataFirst === true) {
        history.push("/admindashboard/changepassword");
      } else {
        history.push("/admindashboard");
      }
    } else if (localStorage.getItem("UserId") && type === "clouduser") {
      history.push("/clouddashboard");
    }
    else if (localStorage.getItem("UserId") && type === "property_manager") {
      history.push("/property-manager-dashboard")
    }
    else if (localStorage.getItem("UserId") && type === "property_user") {
      history.push("/clouddashboard")
    }
    else {
      // history.push("/login");
    }
  }, [props.verifyTokenUser]);

  useEffect(() => {
    getCookies();
  }, []);
  const getCookies = () => {
    let UCustomerId = getCookie("UsercustomerId");
    let UAccountNumber = getCookie("UserAccountNo");
    let UPassword = getCookie("Userpassword");
    let UMobileNumber = getCookie("UserMobileNo");
    if (UCustomerId && UAccountNumber && UPassword && UMobileNumber) {
      let user = {
        customerId: UCustomerId,
        AccountNo: UAccountNumber,
        password: UPassword,
        MobileNo: UMobileNumber,
      };
      setData(user);
      setRememberMe(true);
      setInitCustomerId(UCustomerId);
      setInitAccountNumber(UAccountNumber);
      setInitPassword(UPassword);
      setInitMobileNumber(UMobileNumber);
    }
  };

  const setCookies = (event) => {
    if (rememberMe) {
      let time = new Date();
      time.setTime(time.getTime() + 24 * 60 * 60 * 1000 * 30);
      let c = `UsercustomerId=${data.customerId
        };expires=${time.toUTCString()};`;
      let d = `UserAccountNo=${data.AccountNo};expires=${time.toUTCString()};`;
      let e = `Userpassword=${data.password};expires=${time.toUTCString()};`;
      let f = `UserMobileNo=${data.MobileNo};expires=${time.toUTCString()};`;
      document.cookie = c;
      document.cookie = d;
      document.cookie = e;
      document.cookie = f;
      setRememberMe(true);
    } else {
      clearListCookies();
      getCookies();
      setRememberMe(false);
    }
  };

  function clearListCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var spcook = cookies[i].split("=");
      deleteCookie(spcook[0]);
    }
    getCookies();
    // window.location = ""; // TO REFRESH THE PAGE
  }

  function deleteCookie(cookiename) {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    var expires = ";expires=" + d;
    var name = cookiename;
    var value = "";
    document.cookie = name + "=" + value + expires + ";";
  }

  const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };
  const userLicenceInfo = (userId, license, startDate, endDate) => {
    return `${userId}/${license}/${startDate}/${endDate}`;
  };

  let handleValidSubmit = async (event, values) => {
    event.preventDefault();
  };

  const [data, setData] = useState({
    customerId: "",
    AccountNo: "",
    password: "",
    MobileNo: "",
  });
  const onInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const loginSave = async () => {
    try {
      showLoader();
      console.log("hello world")
      if (
        data.customerId == "" ||
        data.AccountNo == "" ||
        data.MobileNo == "" ||
        data.password == ""
      ) {
        hideLoader();
        ErrorMessage("Please fill the all Customer details.");
        return;
      }
      if (data.customerId === "Admin") {
        hideLoader();
        ErrorMessage("Super-Admin login is not allowed here");
        return;
      } else {
        let res = await httpService
          .CreateUpdate("getloginapi", data)
          .catch((err) => {
            if (err) {
              hideLoader();
              ErrorMessage("Something went wrong");
              return;
            }
          });
        if (res) {
          if (
            res.data &&
            res.data.data &&
            res.data.data.type &&
            res.data.data.type === "admin"
          ) {
            hideLoader();
            ErrorMessage("Super-Admin login is not allowed here ");
            return;
          }
          // if (res.data && res.data.data && res.data.data.type && res.data.data.type === "normal") {
          //   hideLoader();
          //   ErrorMessage("Property-User login is not allowed here ")
          //   return;
          // }
          if (res.data && res.data.message === "login successfull") {
            SuccessMessage("Login Successfully ");
            if (rememberMe) {
              setCookies();
            } else {
              clearListCookies();
            }
            // userLicenceInfo(res.data.data._id,res.data.data.licenceNo,res.data.data.startDate,res.data.data.endDate)

            localStorage.setItem("isSession", true);
            localStorage.setItem("customerId", data.customerId);
            localStorage.setItem("UserId", res.data.data._id);
            localStorage.setItem(
              "Licence",
              encryptText(
                userLicenceInfo(
                  res.data.data._id,
                  res.data.data.licenceNo,
                  res.data.data.startDate,
                  res.data.data.endDate
                ),
                res.data.data._id
              )
            );
            localStorage.setItem("token", res.data.token);
            props.setVerifyTokenUser(true);
            localStorage.setItem(
              "CloudUserType",
              res.data.data.type.toLowerCase()
            );
            const dataFirst = localStorage.getItem("dataFirst");
            if (data.customerId === "Admin") {
              if (data.customerID === "Admin" && dataFirst === true) {
                history.push("/admindashboard/changepassword");
              } else {
                history.push("/admindashboard");
              }
            } else {
              history.push({
                pathname: "/clouddashboard",
                // search: "?query=abc",
                state: { detail: res.data.data },
              });
            }
          } else {
            ErrorMessage(res.data && res.data.message);
            localStorage.setItem("isSession", false);
            history.push("/cloudlogin");
          }
        }
      }
      hideLoader();

    } catch (error) {
      console.log(error, "Errpradfasd")
    }

  };
  const showLoader = () => {
    setLoading(true);
  };
  const hideLoader = () => {
    setLoading(false);
  };

  const getExpiryDate = (userName) => {
    httpService
      .CreateUpdate("getexpirydatebyname", { userName })
      .then((data) => {
        console.log(data);
        if (data?.data?.ack == 1) setExpiry(data?.data?.data);
        else setExpiry("");
        // ErrorMessage("User not found!")
      })
      .catch((err) => {
        if (err) {
          setExpiry("");
          ErrorMessage("Something went wrong");
          return;
        }
      });
  };
  return (
    <div>
      {loading ? <Loader /> : null}

      {login ? (
        <div>
          <div className="home-btn d-none d-sm-block">
            <i className="bx bx-home h2"></i>
          </div>
          <div className="account-pages">
            <Container>
              <Row className="justify-content-center">
                <Col md={12} lg={11} xl={8}>
                  <Card className="overflow-hidden login-wrapper">
                    <CardBody className="row">
                      <div className="col-6 p-0">
                        <div className="login-img">
                          <img src={loginImg} alt="LoginImage" />
                        </div>
                      </div>
                      <div className="col-6 p-0">
                        <div className="login-right">
                          <div className="login-txthead">Cloud User Login</div>
                          <p className="signText">
                            Sign in to continue to RSD.
                          </p>
                          <div className="">
                            {expiry && (
                              <h5 className="signText">
                                Expiry on <strong>{expiry}</strong>
                              </h5>
                            )}
                            <form
                              className="form-horizontal login-form"
                              onSubmit={handleValidSubmit}
                            >
                              <div className="form-group">
                                <span className="input-icon">
                                  <i className="fa fa-user"></i>
                                </span>
                                <input
                                  name="customerId"
                                  value={data.customerId}
                                  onBlur={(e) => getExpiryDate(e.target.value)}
                                  className="form-control formInput"
                                  placeholder="Account Name"
                                  type="text"
                                  onChange={(e) => {
                                    setRememberMe(
                                      initcustomerId === e.target.value
                                    );
                                    const regex = /^[a-zA-Z0-9_ ]*$/
                                    const { value } = e.target

                                    if (regex.test(value)) {
                                      onInputChange(e);
                                    }
                                  }}
                                // validate={{
                                //   required: {
                                //     value: true,
                                //     errorMessage: "Required",
                                //   },
                                // }}
                                />
                              </div>
                              <div className="form-group">
                                <span className="input-icon">
                                  <i className="fa fa-user"></i>
                                </span>
                                <input
                                  name="AccountNo"
                                  value={data.AccountNo}
                                  className="form-control formInput"
                                  placeholder="Account Number"
                                  type="text"
                                  onChange={(e) => {
                                    setRememberMe(
                                      initaccountNumber === e.target.value
                                    );
                                    const regex = /^[a-zA-Z0-9-]*$/
                                    const { value } = e.target

                                    if (regex.test(value)) {
                                      onInputChange(e);
                                    }
                                  }}
                                  maxLength="14"
                                // validate={{
                                // required: {
                                // value: true,
                                // errorMessage: "Required",
                                // },
                                // }}
                                />
                              </div>
                              <div className="form-group">
                                <span className="input-icon">
                                  <i className="fa fa-lock"></i>
                                </span>
                                <input
                                  name="password"
                                  value={data.password}
                                  type="password"
                                  className="form-control formInput"
                                  onChange={(e) => {
                                    setRememberMe(
                                      initpassword === e.target.value
                                    );
                                    onInputChange(e);
                                  }}
                                  placeholder="Password"
                                // validate={{
                                //   required: {
                                //     value: true,
                                //     errorMessage: "Required",
                                //   },
                                // }}
                                />
                              </div>
                              <div className="form-group">
                                <span className="input-icon">
                                  <i className="fa fa-lock"></i>
                                </span>
                                <input
                                  name="MobileNo"
                                  value={data.MobileNo}
                                  className="form-control formInput"
                                  type="text"
                                  maxLength="10"
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    const regex = /^[0-9]*$/;

                                    if (regex.test(value)) {
                                      onInputChange(e);
                                    }

                                    if (value.length === 10) {
                                      setRememberMe(initmobileNumber === value);
                                    }
                                  }}
                                  placeholder="Mobile Number"
                                />
                              </div>

                              <div className="custom-control custom-checkbox ml-0" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div>
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="customControlInline"
                                    checked={rememberMe}
                                    onChange={(e) => {
                                      setRememberMe(!rememberMe);
                                    }}
                                  />
                                  <label
                                    className="custom-control-label pt-1"
                                    htmlFor="customControlInline"
                                  >
                                    {" "}
                                    Remember me
                                  </label>
                                </div>
                                <div style={{ color: "blue", cursor: "pointer" }} onClick={() => history.push("/forget-password")} >Forget Password?</div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: 2,
                                  marginTop: 10,
                                }}
                              >
                                <div className="" style={{ width: "100%" }}>
                                  <button
                                    className="btn btn-primary"
                                    type="submit"
                                    onClick={() => loginSave()}
                                  >
                                    Log In
                                  </button>
                                </div>
                                <div style={{ fontSize: 17 }}>OR</div>
                                <div className="" style={{ width: "100%" }}>
                                  <div
                                    className="btn btn-primary"
                                    style={{ backgroundColor: "#48a942" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      history.push("/createUser");
                                    }}
                                  >
                                    Sign Up
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      ) : (
        <Redirect to="/clouddashboard" />
      )}
    </div>
  );
};

export default CloudLogin;
